/**
 * Où mène chaque étape d'installation.
 *
 * L'écran d'installation proposait « Marquer faite » sur les onze étapes, y
 * compris celles qui ne configurent rien. Une étape se coche parce qu'elle est
 * FAITE, pas parce qu'on a cliqué : chacune renvoie donc vers son réglage, et
 * celles qui n'en ont pas encore le disent.
 */

export interface DestinationEtape {
  /** Lien vers l'écran qui fait le travail. */
  readonly lien?: string;
  readonly libelleAction?: string;
  /** Pourquoi l'étape n'a pas encore d'écran — affiché tel quel. */
  readonly indisponible?: string;
}

export const DESTINATIONS: Record<string, DestinationEtape> = {
  IDENTITE_LEGALE: {
    lien: '/parametres',
    libelleAction: 'Renseigner',
  },
  MARQUE: {
    lien: '/parametres',
    libelleAction: 'Renseigner',
  },
  EXPLOITATION: {
    lien: '/parametres',
    libelleAction: 'Renseigner',
  },
  FISCALITE: {
    indisponible:
      'En attente de l’arbitrage A08 : le paramétrage fiscal doit être confirmé par un ' +
      'expert-comptable avant d’être codé.',
  },
  NUMEROTATION: {
    indisponible: 'Viendra avec la facturation (Lot 3).',
  },
  ROLES: {
    indisponible:
      'Les 7 rôles modèles sont déjà en place. Leur ajustement demande un écran de gestion ' +
      'des droits, non écrit.',
  },
  UTILISATEURS: {
    lien: '/utilisateurs',
    libelleAction: 'Inviter',
  },
  DEPOTS: {
    indisponible: 'Viendra avec le module Stock (Lot 3).',
  },
  IMPORT_CATALOGUE: {
    indisponible: 'Le catalogue d’articles viendra avec le Lot 3.',
  },
  IMPORT_TIERS: {
    lien: '/import',
    libelleAction: 'Importer',
  },
  IMPORT_MACHINES: {
    lien: '/machines/import',
    libelleAction: 'Importer',
  },
};
